import { render, staticRenderFns } from "./index.vue?vue&type=template&id=774f3db0&scoped=true&"
import script from "./zPayLoginCard.js?vue&type=script&lang=js&"
export * from "./zPayLoginCard.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=774f3db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f3db0",
  null
  
)

export default component.exports